var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid bg-white"},[_c('form-toolbar'),_c('forms-tab',{attrs:{"title":'Completed Forms for ' + _vm.$store.company.company_name}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }